import { Attributes, NeoModel, Validation, ValueObject } from "@singularsystems/neo-core";

@NeoModel
export default class RawGenericMappingSearchCriteria extends ValueObject {
    public sourceTable: string = "";

    public destinationTableId: number = 0;

    public sourceField: string = "";

    public destinationFieldId: number = 0;

    public defaultValue: string = "";

    @Attributes.NullableBoolean()
    public isGenericJoinField: boolean | null = null;

    @Attributes.Integer()
    public iteration: number = 0;

    protected addBusinessRules(rules: Validation.Rules<this>) {
        super.addBusinessRules(rules);
    }
}